import { render, staticRenderFns } from "./blood-config.vue?vue&type=template&id=21892ab5&scoped=true"
import script from "./blood-config.vue?vue&type=script&lang=js"
export * from "./blood-config.vue?vue&type=script&lang=js"
import style0 from "./blood-config.vue?vue&type=style&index=0&id=21892ab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21892ab5",
  null
  
)

export default component.exports